/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Vs_Yaml_Xml_S1_P1Inputs */

const en_guide_json_vs_yaml_xml_s1_p1 = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_S1_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All three formats can represent hierarchical, structured data, but they differ in syntax, readability, features, and ecosystem support. Here's a high-level comparison:`)
};

const ko_guide_json_vs_yaml_xml_s1_p1 = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_S1_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`세 가지 포맷 모두 계층적이고 구조화된 데이터를 표현할 수 있지만, 구문, 가독성, 기능, 생태계 지원 면에서 차이가 있습니다. 주요 비교 사항은 다음과 같습니다:`)
};

const ja_guide_json_vs_yaml_xml_s1_p1 = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_S1_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3つのフォーマットはすべて階層的な構造化データを表現できますが、構文、可読性、機能、エコシステムのサポートが異なります。以下は概要比較です：`)
};

/**
* | output |
* | --- |
* | "All three formats can represent hierarchical, structured data, but they differ in syntax, readability, features, and ecosystem support. Here's a high-level c..." |
*
* @param {Guide_Json_Vs_Yaml_Xml_S1_P1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_vs_yaml_xml_s1_p1 = /** @type {((inputs?: Guide_Json_Vs_Yaml_Xml_S1_P1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Vs_Yaml_Xml_S1_P1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_vs_yaml_xml_s1_p1(inputs)
	if (locale === "ko") return ko_guide_json_vs_yaml_xml_s1_p1(inputs)
	return ja_guide_json_vs_yaml_xml_s1_p1(inputs)
});